// extracted by mini-css-extract-plugin
export default {"copyrightTextContainer":"CopyrightFooter_copyrightTextContainer__UhR9J","copyrightText":"CopyrightFooter_copyrightText__JI81e"};